import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { getOrFetchTrack } from '@disco/state-management/actions/PlaylistTrackActions'
import { getTrack } from '@disco/state-management/selectors/tracks'

import type { TrackId } from 'types/track'

import DocumentHeadTags from 'components/document-head-tags'
import { Dialog, Spinner, Text } from 'components/ds'
import AggregatedTrackShareModal from 'components/modals/track/aggregated-track-share'
import TrackShareModal from 'components/modals/track/share'

import { useDispatch, useSelector } from 'hooks/use-redux'

const TrackShare = (): React.ReactNode => {
  const params = useParams<{
    trackId: string
    sourceLibraryId?: string
  }>()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const trackId = parseInt(params.trackId!, 10) as TrackId
  const track = useSelector(state =>
    getTrack(state, {
      id: trackId,
    }),
  )

  const onClose = () => navigate('/')

  useEffect(() => {
    if (!track) {
      if (
        params.sourceLibraryId &&
        !isNaN(parseInt(params.sourceLibraryId, 10))
      ) {
        dispatch(getOrFetchTrack(trackId, parseInt(params.sourceLibraryId, 10)))
      } else {
        dispatch(getOrFetchTrack(trackId))
      }
    }
  }, [track, trackId, params.sourceLibraryId, dispatch])

  if (!track) {
    return (
      <>
        <DocumentHeadTags title="Share track | DISCO" />
        <Dialog.Root defaultOpen onOpenChange={onClose}>
          <Dialog.Content maxWidth="700px" align="start">
            <Dialog.Title>
              <Text size="6" weight="bold" mb="3" as="div">
                Share Track
              </Text>
            </Dialog.Title>
            <Spinner size="3" />
          </Dialog.Content>
        </Dialog.Root>
      </>
    )
  }

  return (
    <>
      <DocumentHeadTags title="Share track | DISCO" />
      {params.sourceLibraryId ? (
        <AggregatedTrackShareModal track={track} onClose={onClose} />
      ) : (
        <TrackShareModal
          track={track}
          onClose={onClose}
          sharedChannel={params.sourceLibraryId === 'shared-channel'}
        />
      )}
    </>
  )
}

export default TrackShare
